import { AppRouter } from './router/AppRouter';
import { AuthProvider } from './context/AuthContext';
import './assets/styles/app.scss';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Chat } from 'stream-chat-react';
import { getStreamClient } from './api/chat';
import 'stream-chat-react/dist/css/v2/index.css';
import GoogleTagManager, { GoogleTagManagerBody } from './components/GoogleTagManager/GoogleTagManager';

function App() {
  const favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement;
  if (process.env.REACT_APP_ENV === 'dev' && favicon) {
    favicon.href = '/favicon-dev.ico';
  } else {
    favicon.href = '/favicon.ico';
  }
  
  const client = getStreamClient();
  
  return (
    <div className='app'>
      <GoogleTagManager />
      <AuthProvider>
        <Chat client={client}>
          <AppRouter />
        </Chat>
        <ToastContainer />
        <GoogleTagManagerBody />
      </AuthProvider>
    </div>
  );
}

export default App;

// https://elevate-olearis.s3.eu-north-1.amazonaws.com/static/Badges.png
// https://elevate-olearis.s3.eu-north-1.amazonaws.com/static/Badges (1).png
// https://elevate-olearis.s3.eu-north-1.amazonaws.com/static/Course Up.png
// https://elevate-olearis.s3.eu-north-1.amazonaws.com/static/User Check.png
// https://elevate-olearis.s3.eu-north-1.amazonaws.com/static/Round Arrow Right Up.png
// https://elevate-olearis.s3.eu-north-1.amazonaws.com/static/rb_4113 1.png
// https://elevate-olearis.s3.eu-north-1.amazonaws.com/static/Logo (6).png
// https://elevate-olearis.s3.eu-north-1.amazonaws.com/static/Gradient.webp
// https://elevate-olearis.s3.eu-north-1.amazonaws.com/static/Gradient.png
// https://elevate-olearis.s3.eu-north-1.amazonaws.com/static/2Gradient.png
